export default __webpack_public_path__ + "static/media/ogilvy.ea2a5b7e.svg";